import * as actionType from "./actionTypes";
import { API_URL } from "../../constants/api";
import { apiRequestAsync } from "../../utils/api_service";

/** Set Error Message */
export const setErrorMessage = (commonLabel) => (dispatch) => {
  dispatch({
    type: actionType.SET_ERROR_PAGE,
    payload: commonLabel,
  });
};

/** Notification Master - pending notifications */
export const getNotificationMaster = () => dispatch => {
  apiRequestAsync({
    url: API_URL.Notification.List,
    key: "pendingNotifications"
  }).then((pendingNotifications) => {
    let sorted = [];
    if (pendingNotifications.success) {
      sorted = pendingNotifications?.data?.sort((a, b) => {
        const aDate = new Date(a.createdOn);
        const bDate = new Date(b.createdOn);
        return bDate.getTime() - aDate.getTime();
      });
    }
    dispatch({
      type: actionType.GET_NOTIFICATION_DATA,
      payload: sorted
    });
  });
};

/** Notification master - Pending notifications */
export const getNotificationMasterData = () => (dispatch) => {
  apiRequestAsync({
    url: API_URL.Notification.List,
    key: "pendingNotifications"
  }).then((pendingNotifications) => {
    let sorted = [];
    if (pendingNotifications.success) {
      sorted = pendingNotifications?.data?.sort((a, b) => {
        const aDate = new Date(a.createdOn);
        const bDate = new Date(b.createdOn);
        return bDate.getTime() - aDate.getTime();
      });
    }
    dispatch({
      type: actionType.GET_NOTIFICATION_DATA,
      payload: sorted
    });
  });
};